import { render } from "./WCItemModifierCategory.vue?vue&type=template&id=ca67e75e&scoped=true"
import script from "./WCItemModifierCategory.vue?vue&type=script&lang=js"
export * from "./WCItemModifierCategory.vue?vue&type=script&lang=js"

import "./WCItemModifierCategory.vue?vue&type=style&index=0&id=ca67e75e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca67e75e"]])

export default __exports__